import $ from 'jquery';
window.$ = window.jQuery = require('jquery');

// $(document).ready(function () {});

import UIkit from 'uikit';
import slick from 'slick-carousel';


// ------------------------------------------------------------
// CHECK WINDOW WIDTH FOR SPECIFIC NAV INTERACTIONS
// ------------------------------------------------------------
function checkWidth() {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    // $('.menu-wrap').hide();
    $('.js-menu-trigger').click(function() {
      $('.js-menu').show();
    });
    
    $('.js-menu-close').click(function(){
      $('.js-menu').hide();
    });
  } else {
	  $('.js-menu').show();
  }
}
checkWidth();

$(window).resize(checkWidth);



// ------------------------------------------------------------
// NAV ANIMATION ON SCROLL
// ------------------------------------------------------------
function updateScroll() {
   let nav = $('.nav');

   if ($(window).scrollTop() >= 150) {
      $(nav).addClass('solid');
   } else {
      $(nav).removeClass('solid');
   }
}

$(function() {
   $(window).scroll(updateScroll);
   updateScroll();
});



$('.featured-projects__block').bind('touchstart', function() {
   $('.featured-projects__block').addClass('hidden');
   $(this).removeClass('hidden');
 });